import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-activity-calendar-icon',
  templateUrl: './activity-calendar-icon.component.html',
  styleUrls: ['./activity-calendar-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityCalendarIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
